import { useCardData } from 'components/providers/CardDataProvider'
import { getUserStock } from 'lib/api'
import { useCallback, useMemo } from 'react'
import { Article, Card, IdGame, InventoryArticle } from 'shared'

// card data is loaded per game, so this can only hydrate articles of the active game
export const useHydrateArticles = () => {
  const cardData = useCardData()

  // const cardDataSorted = useMemo(() => cardData.sort((a, b) => a._id - b._id), [cardData])

  const cardDataMap = useMemo(() => {
    const map = new Map<number, Card>()
    for (const card of cardData) {
      map.set(card._id, card)
    }
    return map
  }, [cardData])

  return useCallback(
    (articles: Article['attributes'][]) => {
      const result: InventoryArticle[] = []
      for (const d of articles) {
        const article = new Article({ attributes: d })
        const card = cardDataMap.get(article.idProduct)
        if (card) {
          result.push(new InventoryArticle({ attributes: d, card: card.toPlainObject() }))
        }
      }
      return result
    },
    [cardDataMap]
  )
}

export const useFetchUserStock = () => {
  const hydrateArticles = useHydrateArticles()

  const fetchUserStock = useCallback(
    async (idGame: IdGame) => {
      const data = await getUserStock(idGame)

      return {
        stock: hydrateArticles(data.stock),
        sealedStock: hydrateArticles(data.sealedStock),
        // left raw: these are hydrated when their game is opened
        otherGames: data.otherGames,
      }
    },
    [hydrateArticles]
  )

  return fetchUserStock
}
